import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { DesignCatalogsPage } from "src/routes/libraries/design-catalog/DesignCatalogsPage";
import { DesignPackageCompareModePage } from "src/routes/libraries/design-catalog/compare-mode/DesignPackageCompareMode";
import { DesignPackageConfigurator } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageConfigurator";
import { DesignPackageConfiguratorLayout } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageConfiguratorLayout";
import { DesignPackageProductCardPage } from "src/routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage";
import { AddProductPage } from "src/routes/libraries/design-catalog/design-package-configurator/components/AddProductPage";
import { DesignPackageRequiredOptionsPage } from "src/routes/libraries/design-catalog/design-package-configurator/components/DesignPackageRequiredOptionsPage";
import { ProductSearchPage } from "src/routes/libraries/design-catalog/design-package-configurator/routes/search/ProductSearchPage";
import { FinishSchedulePage } from "src/routes/libraries/design-catalog/finish-schedules/FinishSchedulePage";
import { DesignPackagePersonalizationGroupsPage } from "src/routes/libraries/design-catalog/personalization-groups/DesignPackagePersonalizationGroupsPage";
import { EditPersonalizationOptionWizard } from "src/routes/libraries/design-catalog/personalization-option/EditPersonalizationOptionWizard";
import { DesignPackageVersionHistoryPage } from "src/routes/libraries/design-catalog/version-history/DesignPackageVersionHistoryPage";
import { AppShell } from "src/routing/components/AppShell";
import { BeamNavbarLayout } from "src/routing/components/layouts/BeamNavbarLayout";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as designPackagesPaths from "src/routing/domains/libraries/design-packages/designPackagesPaths";

/**
 * `/libraries/design-packages/*` route tree.
 *
 * Role: data router domain route.
 *
 * Two layout stacks coexist during migration:
 * - **New (Beam):** `AppShell` → `BeamNavbarLayout` → page (index using `PageHeaderLayout` / `GridTableLayout`)
 * - **Legacy:** `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page
 *   (detail/wizard pages not yet on Beam nav). Configurator nest adds `DesignPackageConfiguratorLayout`.
 *   Edit personalization option wizard skips `ScrollableParentLayout` (full-bleed).
 */
export const designPackagesRoutes: RouteObject = {
  path: designPackagesPaths.designPackagesRoute.path,
  Component: AppShell,
  children: [
    { Component: BeamNavbarLayout, children: [{ index: true, Component: DesignCatalogsPage }] },
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            {
              path: designPackagesPaths.designPackageVersionHistoryRoute.path,
              Component: DesignPackageVersionHistoryPage,
            },
            {
              path: designPackagesPaths.designPackagePersonalizationGroupsRoute.path,
              Component: DesignPackagePersonalizationGroupsPage,
            },
            { path: designPackagesPaths.designPackageFinishScheduleRoute.path, Component: FinishSchedulePage },
            { path: designPackagesPaths.designPackageCompareModeRoute.path, Component: DesignPackageCompareModePage },
            {
              path: designPackagesPaths.designPackageRequiredOptionsRoute.path,
              Component: DesignPackageRequiredOptionsPage,
            },
            {
              path: designPackagesPaths.designPackageRoute.path,
              Component: DesignPackageConfiguratorLayout,
              children: [
                { index: true, Component: DesignPackageConfigurator },
                { path: designPackagesPaths.designPackageProductCardPath, Component: DesignPackageProductCardPage },
                { path: designPackagesPaths.designPackageProductSearchPath, Component: ProductSearchPage },
                { path: designPackagesPaths.designPackageAddProductPath, Component: AddProductPage },
              ],
            },
          ],
        },
        { path: designPackagesPaths.designPackageEditOptionRoute.path, Component: EditPersonalizationOptionWizard },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
